import React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { InfoTooltip } from '#src/app/shared/components/tooltips';
import { useTrackView } from '#src/app/shared/hooks/tracking';

import { BarChart } from './components/BarChart';
import { InsightBox } from './components/InsightBox';
import { useTopSignatureSources } from './hooks/useTopSignatureSources';

export const TopSignatureSources: React.FC = () => {
	const {
		data: { topChannel, showInsightBox, promoteLink, channelSignatureCounts, otherSignatureSource },
		actions: { handlePromoteClick, handleShareClick },
	} = useTopSignatureSources();

	useTrackView('petition_manage_signature_insights_section_view', { topChannel: topChannel?.channel });

	// Not technically possible because the component should not render without data
	if (channelSignatureCounts.length === 0) return null;

	return (
		<section className="flex flex-col gap-6" aria-labelledby="top-signature-sources">
			<div>
				<div className="flex items-center gap-1">
					<Text className="text-size-heading-small" id="top-signature-sources" as="h3">
						<Translate value="corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.title" />
					</Text>
					<InfoTooltip aria-describedby="top-signature-sources">
						<Translate value="corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.tip" />
					</InfoTooltip>
				</div>
				<BarChart allChannels={channelSignatureCounts} otherSignatureSource={otherSignatureSource} />
			</div>
			{topChannel && showInsightBox ? (
				<InsightBox
					topChannel={topChannel}
					promoteLink={promoteLink}
					handlePromoteClick={handlePromoteClick}
					handleShareClick={handleShareClick}
				/>
			) : null}
		</section>
	);
};
